/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Billing_Voucher_InvalidInputs */

const en_billing_voucher_invalid = /** @type {(inputs: Billing_Voucher_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`That code isn't valid.`)
};

const id_billing_voucher_invalid = /** @type {(inputs: Billing_Voucher_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kode itu tidak valid.`)
};

/**
* | output |
* | --- |
* | "That code isn't valid." |
*
* @param {Billing_Voucher_InvalidInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const billing_voucher_invalid = /** @type {((inputs?: Billing_Voucher_InvalidInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Billing_Voucher_InvalidInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_billing_voucher_invalid(inputs)
	return en_billing_voucher_invalid(inputs)
});